export const getApexReference = (job) => {
  const match = `${job.notes || ''}\n${job.description || ''}`.match(/\b(TKT|BKG|WRN)-\d{3,6}\b/i);
  return match ? match[0].toUpperCase() : '';
};

export const matchesJobSearch = (job, search) => {
  const query = search.trim().toLowerCase();
  return !query || getApexReference(job).toLowerCase().includes(query) || (job.customer_name || '').toLowerCase().includes(query);
};

export const jobErrorMessage = (error, fallback) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg).join(' · ');
  if (detail?.message) return [detail.message, ...(detail.conflicts || [])].join(' ');
  return fallback;
};